import { CredentialsState } from "./interface";

export const CREDENTIALS_INITIAL_STATE: CredentialsState = {
  password: {
    validThrough: null,
    isDirty: false,
    persistedValue: null,
  },
  crypto: {
    salt: null,
    iv: null,
    encrypted: null,
  },
};
